export type BobPageType = (typeof BOB_PAGES)[keyof typeof BOB_PAGES];
export type BobModalType = (typeof BOB_MODALS)[keyof typeof BOB_MODALS];

export const maxNumberOfVaults = 15;

export const BOB_PAGES = {
  HOME: "home",
  RECEIVE: "receive",
  RECEIVE_ONCHAIN: "receive-onchain",
  SEND: "send",
  SEND_ONCHAIN: "send-onchain",
  SEND_USDT: "send-usdt",
  GIFT_CARD: "gift-card",
  NWC: "nwc",
  TRANSACTIONS_LIST: "transactions-list",
  HOLD_INVOICES: "hold-invoices",
};

export const BOB_MODALS = {
  SET_RECEIVE_AMOUNT: "set-receive-amount",
  SINGLE_NOSTR_CONNECTION: "single-nostr-connection",
  SET_USER_PROVIDED_NOSTR_PUBLIC_KEY: "set-user-provided-nostr-public-key",
  EDIT_ALIAS: "edit-alias",
  DESTROY_WALLET: "destroy-wallet",
  YOU_MUST_REFRESH_THE_PAGE: "you-must-refresh-the-page",
  SETTINGS: "settings",
  VIEW_TRANSACTION: "view-transaction",
  CREATE_NEW_BOB: "create-new-bob",
  TWO_FACTOR_TIMEOUT: "two-factor-timeout",
  NWC_SECURE: "nwc-secure",
  NWC_ENTRY: "nwc-entry",
  OUR_INVOICE_WAS_PAID: "our-invoice-was-paid",
  PAY_ATTEMPT_WAS_SUCCESSFUL: "payattempt-successful",
  PAY_ATTEMPT_FAILED: "payattempt-failed",
  SELECT_BOB: "select-bob",
  PROMO_CODE: "promo-code",
  SPONSORSHIP: "sponsorship",
  CREATE_HOLD_INVOICE: "create-hold-invoice",
  HOLD_INVOICE_NEEDS_DECISION: "hold-invoice-needs-decision",
  HOLD_INVOICE_WAS_ACCEPTED: "hold-invoice-was-accepted",
};

// TikTok sponsorships ended; hides the Sponsorship menu item and stops promo
// codes from opening the sponsorship modal. Gift card promo codes still work.
export const TIKTOK_SPONSORSHIPS_ENABLED = false;

export const MAX_BALANCE_SATOSHIS_TO_ALLOW_BOB_DELETE = 100;

export const currencyCodes = [
  "aed",
  "ars",
  "aud",
  "bdt",
  "bhd",
  "bmd",
  "brl",
  "cad",
  "chf",
  "clp",
  "cny",
  "czk",
  "dkk",
  "eur",
  "gbp",
  "gel",
  "hkd",
  "huf",
  "idr",
  "ils",
  "inr",
  "jpy",
  "krw",
  "kwd",
  "lkr",
  "mmk",
  "mxn",
  "myr",
  "ngn",
  "nok",
  "nzd",
  "php",
  "pkr",
  "pln",
  "rub",
  "sar",
  "sek",
  "sgd",
  "thb",
  "try",
  "twd",
  "uah",
  "usd",
  "vef",
  "vnd",
  "zar",
];

export const currencyDisplayNames: { [code: string]: string } = {
  aed: "AED (United Arab Emirates Dirham)",
  ars: "ARS (Argentine Peso)",
  aud: "AUD (Australian Dollar)",
  bdt: "BDT (Bangladeshi Taka)",
  bhd: "BHD (Bahraini Dinar)",
  bmd: "BMD (Bermudian Dollar)",
  brl: "BRL (Brazilian Real)",
  cad: "CAD (Canadian Dollar)",
  chf: "CHF (Swiss Franc)",
  clp: "CLP (Chilean Peso)",
  cny: "CNY (Chinese Yuan)",
  czk: "CZK (Czech Koruna)",
  dkk: "DKK (Danish Krone)",
  eur: "EUR (Euro)",
  gbp: "GBP (British Pound)",
  gel: "GEL (Georgian Lari)",
  hkd: "HKD (Hong Kong Dollar)",
  huf: "HUF (Hungarian Forint)",
  idr: "IDR (Indonesian Rupiah)",
  ils: "ILS (Israeli New Shekel)",
  inr: "INR (Indian Rupee)",
  jpy: "JPY (Japanese Yen)",
  krw: "KRW (South Korean Won)",
  kwd: "KWD (Kuwaiti Dinar)",
  lkr: "LKR (Sri Lankan Rupee)",
  mmk: "MMK (Burmese Kyat)",
  mxn: "MXN (Mexican Peso)",
  myr: "MYR (Malaysian Ringgit)",
  ngn: "NGN (Nigerian Naira)",
  nok: "NOK (Norwegian Krone)",
  nzd: "NZD (New Zealand Dollar)",
  php: "PHP (Philippine Peso)",
  pkr: "PKR (Pakistani Rupee)",
  pln: "PLN (Polish Zloty)",
  rub: "RUB (Russian Ruble)",
  sar: "SAR (Saudi Riyal)",
  sek: "SEK (Swedish Krona)",
  sgd: "SGD (Singapore Dollar)",
  thb: "THB (Thai Baht)",
  try: "TRY (Turkish Lira)",
  twd: "TWD (New Taiwan Dollar)",
  uah: "UAH (Ukrainian Hryvnia)",
  usd: "USD (United States Dollar)",
  vef: "VEF (Venezuelan Bolívar)",
  vnd: "VND (Vietnamese Dong)",
  zar: "ZAR (South African Rand)",
};

export const TWO_FACTOR_INTERVALS = [
  { value: "1", label: "1 minute" },
  { value: "20", label: "20 minutes" },
  { value: "720", label: "12 hours" },
  { value: "1440", label: "24 hours" },
  { value: "10080", label: "1 week" },
  { value: "43200", label: "30 days" },
  { value: "525600", label: "365 days" },
];
